import { render, staticRenderFns } from "./speciallist.vue?vue&type=template&id=4bd037e4&scoped=true&"
import script from "./speciallist.vue?vue&type=script&lang=js&"
export * from "./speciallist.vue?vue&type=script&lang=js&"
import style0 from "./speciallist.vue?vue&type=style&index=0&id=4bd037e4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bd037e4",
  null
  
)

export default component.exports